import { Label } from '@acies/ui';

export default class ListHeaderLabel extends Label {
	public constructor() {
		super();
		this.variant = 'light';
	}
}
customElements.define('ac-list-header-label', ListHeaderLabel);
